/**
 * Public intake for the Australia care-workforce programme.
 *
 * Served by the Ivipass client site inside kv_backend at
 * `/api/ivipass/intake/*`. The source ran this on a separate AWS Lambda +
 * DynamoDB stack; Ivipass consolidates it into the one backend.
 *
 * Only the three public steps live here — send code, verify email, submit.
 * Reading and deleting submissions is an admin job and moved to the portal
 * (`/admin/intake-applications`), where there is a real admin session.
 */
import { apiUrl, JSON_HEADERS, handleResponse, buildQuery, exportToCSV } from './env';

export const ENDPOINTS = {
  SEND_VERIFICATION_CODE: '/intake/send-verification-code',
  VERIFY_EMAIL: '/intake/verify-email',
  SUBMIT_APPLICATION: '/intake/application',
};

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, { headers: JSON_HEADERS, ...options });
  return handleResponse(response);
};

export const careWorkforceApiUtils = {
  handleResponse,
  makeRequest,
  buildQueryString: buildQuery,
  exportToCSV,
};

export const careWorkforceService = {
  sendVerificationCode: async ({ email, fullName }) =>
    makeRequest(apiUrl(ENDPOINTS.SEND_VERIFICATION_CODE), {
      method: 'POST',
      body: JSON.stringify({ email, fullName }),
    }),

  verifyEmail: async ({ email, verificationCode }) =>
    makeRequest(apiUrl(ENDPOINTS.VERIFY_EMAIL), {
      method: 'POST',
      body: JSON.stringify({ email, verificationCode }),
    }),

  submitApplication: async (applicationData) =>
    makeRequest(apiUrl(ENDPOINTS.SUBMIT_APPLICATION), {
      method: 'POST',
      body: JSON.stringify(applicationData),
    }),


};

export default careWorkforceService;
